// Plano 02/10/2026 (Frente 13): modal de ClasseId no padrão visual do modalCadastroProjetista
// (título com botão de fechar, campos obrigatórios com "Obrigatório", botões CANCELAR/SALVAR ao pé).
// Sem mudança de campos nem de endpoints: Código e Descrição em /ClasseId.
import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useNavigation } from "contexts/notificationsContext";
import { salvarCadastro } from "services/modules/cadastrosGerais";

export interface IClasseId {
  idClasseId: number;
  codigo: string;
  descricao: string;
}

interface ModalClasseIdProps {
  isOpen: boolean;
  onClose: () => void;
  refreshData: () => void;
  dataClasseId?: IClasseId;
}

export const ModalClasseId: React.FC<ModalClasseIdProps> = ({ isOpen, onClose, refreshData, dataClasseId }) => {
  const { openNotification } = useNavigation();
  const [loading, setLoading] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [errors, setErrors] = useState<{ codigo?: string; descricao?: string }>({});

  useEffect(() => {
    if (!isOpen) return;
    setCodigo(dataClasseId?.codigo ?? "");
    setDescricao(dataClasseId?.descricao ?? "");
    setErrors({});
  }, [isOpen, dataClasseId]);

  const validar = (): boolean => {
    const novosErros: { codigo?: string; descricao?: string } = {};
    if (!codigo.trim()) novosErros.codigo = "Código é obrigatório";
    if (!descricao.trim()) novosErros.descricao = "Descrição é obrigatória";
    setErrors(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSave = async () => {
    if (!validar()) return;
    setLoading(true);
    try {
      await salvarCadastro("/ClasseId", {
        idClasseId: dataClasseId?.idClasseId ?? 0,
        codigo: codigo.trim(),
        descricao: descricao.trim(),
      });
      openNotification({
        message: dataClasseId ? "ClasseId atualizada com sucesso!" : "ClasseId cadastrada com sucesso!",
        type: "success",
      });
      onClose();
      refreshData();
    } catch (error: any) {
      openNotification({ message: error?.message || "Erro ao salvar ClasseId", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>Cadastro de ClasseId</Grid>
          <Grid item>
            <IconButton onClick={onClose} size="small">
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Código"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              error={!!errors.codigo}
              helperText={errors.codigo || "Obrigatório"}
              inputProps={{ maxLength: 450 }}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Descrição"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              error={!!errors.descricao}
              helperText={errors.descricao || "Obrigatório"}
              required
            />
          </Grid>

          {/* Botões de Ação */}
          <Grid item xs={12} mt={3}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" onClick={onClose} disabled={loading}>
                  CANCELAR
                </Button>
              </Grid>
              <Grid item>
                <LoadingButton variant="contained" onClick={handleSave} loading={loading}>
                  SALVAR
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
